import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { IKontaktDetailViewModel } from '../../models/kontakt-detail.model';
import { AjaxService } from 'AjaxService';
import { EntityArt } from '@enums/entityArt.enum';
import { IDefaultSelectBoxViewModel } from '@shared/models/default-selectBox.model';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'cz-kontakt-modal',
    templateUrl: 'kontakt-modal.component.html',
    styleUrls: ['kontakt-modal.component.css'],
    standalone: false
})
export class KontaktModalComponent implements OnInit {

    @ViewChild('form1', { static: false }) form1: DxFormComponent;
    dirty = false;
    available_KontaktTypeItems: any[];
    private _kontakt: IKontaktDetailViewModel;
    kontaktShadow: IKontaktDetailViewModel;

    @Output() onCloseKontaktModal: EventEmitter<any> = new EventEmitter<any>();
    @Output() onKontaktHasChanged: EventEmitter<IKontaktDetailViewModel> = new EventEmitter<IKontaktDetailViewModel>();

    @Input() showModal: boolean = false;

    @Input()
    set kontakt(value: IKontaktDetailViewModel) {
        if (!value) {
            return;
        }
        this.kontaktShadow = Object.assign({} as IKontaktDetailViewModel, value);
        this._kontakt = value;
    }

    get kontakt(): IKontaktDetailViewModel {
        return this._kontakt;
    }

    constructor(private ajaxService: AjaxService) {
    }

    onValueChanged(event) {
        this.dirty = true;
    }

    ngOnInit(): void {
        this.ajaxService.post<IDefaultSelectBoxViewModel[]>('api/Options/GetEntityForSelectEdit', EntityArt.KontaktType).subscribe(response => {
            this.available_KontaktTypeItems = response.map(v => {
                return {
                    id: v.id,
                    name: v.name,
                    params: v.param
                };
            });
        });
    }

    onClickCloseModal() {
        this.onCloseKontaktModal.emit();
    }

    onClickSaveEdit() {
        const validationResult = this.form1.instance.validate();
        if (!validationResult.isValid) {
            let msg = '';
            for (const err of validationResult.brokenRules) {
                msg += err.message + '\r\n';
            }

            notify({
                message: msg,
                width: 600
            }, 'error', 3000);
        }
        else {
            this.kontakt.isNew = false;
            if (this.dirty) {
                this.copyKontaktValues(this.kontaktShadow, this._kontakt);
                this.onKontaktHasChanged.emit(this._kontakt);
            }
            this.onClickCloseModal();
        }
    }

    private copyKontaktValues(source: IKontaktDetailViewModel, target: IKontaktDetailViewModel) {
        if (source) {
            target.id = source.id;
            target.name = source.name;
            target.vorname = source.vorname;
            target.telefon1 = source.telefon1;
            target.telefon2 = source.telefon2;
            target.fax = source.fax;
            target.mail1 = source.mail1;
            target.mail2 = source.mail2;
            target.webAdresse = source.webAdresse;
            target.ownerId = source.ownerId;
            target.sortIndex = source.sortIndex;
            target.kontaktType = source.kontaktType;
            target.kontaktTypeId = source.kontaktTypeId;
        }
    }
}
